var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeselectAll = function SvgDeselectAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.121 28.5h-21a2 2 0 0 1-2-2v-21a2 2 0 0 1 2-2h13.715a2 2 0 0 1 0 4H8.121v17h17v-4.47a2 2 0 0 1 4 0v6.47a2 2 0 0 1-2 2"
  })));
};
export default SvgDeselectAll;